<div class="buttons" [class.buttons--expanded]="isExpanded">
  <div class="bc-footer-buttons-left">
    <button
      [disabled]="isInteractionDisabled"
      (click)="onReply()"
      data-automation-id="gc-email-footer-on-reply-button"
      class="btn btn-dark bc-footer-button"
    >
      <span>{{ 'genesysEmailFooterControlPanel.reply' | translate }}</span>
    </button>
    <button
      [disabled]="isInteractionDisabled"
      (click)="onForward()"
      data-automation-id="gc-email-footer-on-forward-button"
      class="btn btn-light bc-footer-button"
    >
      <span>{{ 'genesysEmailFooterControlPanel.forward' | translate }}</span>
    </button>
    <button
      [disabled]="isInteractionDisabled"
      (click)="onReplyAll()"
      data-automation-id="gc-email-footer-on-reply-all-button"
      class="btn btn-light bc-footer-button"
    >
      <span>{{ 'genesysEmailFooterControlPanel.replyAll' | translate }}</span>
    </button>
  </div>
  <div class="bc-footer-buttons-right">
    <button
      [disabled]="isInteractionDisabled"
      (click)="handleConfirmation()"
      data-automation-id="gc-email-footer-close-now-button"
      class="btn btn-light bc-footer-button"
    >
      <span>{{ 'genesysEmailFooterControlPanel.closeNow' | translate }}</span>
    </button>
    <button
      [disabled]="isInteractionDisabled"
      (click)="onOpenWrapUpPanel()"
      data-automation-id="gc-email-footer-wrap-up-button"
      class="btn btn-light bc-footer-button"
    >
      <span>{{ 'genesysEmailFooterControlPanel.wrapUp' | translate }}</span>
    </button>
    <button
      *gcUserHasAllPermissions="[gcUserPermission.DirectoryUserView, gcUserPermission.RoutingQueueSearch]"
      [disabled]="isInteractionDisabled"
      (click)="onOpenTransferPanel()"
      class="btn btn-light bc-footer-button"
      data-automation-id="gc-email-footer-transfer-button"
    >
      <span>{{ 'genesysEmailFooterControlPanel.transfer' | translate }}</span>
    </button>
  </div>
</div>
